import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { HomeFooter, SlidesTabs, Copyright } from 'ThreeTerminal_mobile_dynamic';

class NewFooter extends React.PureComponent {
    static propTypes = {
        bottomNav: PropTypes.array,
        content: PropTypes.object,
    };

    state = {
        value: '王宝强离婚案司法程序',
    };

    handleChange = e => {
        const value = e.currentTarget.value;

        this.setState({
            value,
        });
    };

    render() {
        const { value } = this.state;
        const {
            bottomNav,
            content: { nav },
        } = this.props;
        const copyrightConfig = {
            text: '京ICP证030609号',
            url: 'https://beian.miit.gov.cn/',
        };

        return (
            <div className={styles.footer}>
                <div className={styles.search_box}>
                    <form className={styles.search} action="https://i.ifeng.com/search/new_searchJump" method="post">
                        <span className={styles.touch} />
                        <input type="hidden" name="ss" value="1" />
                        <input type="hidden" name="wm" value="1" />
                        <input type="hidden" name="touch" value="1" />
                        <input type="hidden" name="isindex" value="Y" />
                        <input type="hidden" name="search_local" value="search" />
                        <input
                            className={styles.ipt}
                            name="q"
                            type="text"
                            contentEditable="true"
                            value={value}
                            onChange={this.handleChange}
                        />
                        <span className={styles.line} />
                        <input className={styles.submitBtn} name="" type="submit" value="百度一下" />
                        <input type="hidden" name="type" value="baidu_sousuo" />
                    </form>
                </div>
                <Chip id="20002" type="struct" title="页面公用导航" groupName="底部" content={nav}>
                    <SlidesTabs content={nav} currentPath="0" />
                </Chip>
                <div className={styles.bottomNav}>
                    <HomeFooter content={bottomNav} />
                    <Copyright content={copyrightConfig} />
                </div>
            </div>
        );
    }
}

export default errorBoundary(NewFooter);
